// Parse HTML into text and tags, and for each tag call a function if provided.
// Finally, reconstitute and return the string.
// Handlers can return a new string to replace the tag contents, or let the
// parser do the default implementation.
// Text can be handled by a handler with the key 'text'.
// Caveat: <> characters can not currently appear in attribute strings or it'll
// confuse the regex.
export default (function (text, handlers) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var tokens = [];
  if (!text) {
    return text;
  }
  var remainder = text;
  var next = remainder.match(/<[^>]*>/);
  while (next) {
    tokens.push(remainder.substring(0, next.index));
    tokens.push(next[0]);
    remainder = remainder.substring(next.index + next[0].length);
    next = remainder.match(/<[^>]*>/);
  }
  tokens.push(remainder);
  var newTokens = tokens.map(each => {
    // Handle tag tokens
    if (each[0] === '<') {
      var tagBody = each.substring(1, each.length - 1).replace(/^\s+|\s+$/, '');

      // Ignore closing tags
      if (tagBody.startsWith('/')) {
        return each;
      }
      var tagType = tagBody.match(/^[^ ]*/)[0];

      // Handle normal tags via caller-provided function, if any
      if (handlers[tagType]) {
        // Parse out attributes
        var matches = tagBody.substring(2).matchAll(/([^\s]+)\s*=\s*"([^"]*)"/g);
        var attributes = Array.from(matches).reduce((acc, attribute) => {
          acc[attribute[1]] = attribute[2];
          return acc;
        }, {});
        var result = handlers[tagType](tagBody, attributes, context);
        return result || "<".concat(tagType, " ").concat(Object.keys(attributes).map(name => "".concat(name, "=\"").concat(attributes[name], "\"")).join(' '), ">");
      }
      return each;
    }

    // Text token
    return handlers.text ? handlers.text(each, context) : each;
  });

  // Reconstitute the string
  return newTokens.join('');
});